<template>
    <li class="unitCouponWrap">
        <CouponCard
            :validity="expireTimeStr"
            :price='couponAmount'
            :tip="couponExplain"
            :couponname="couponName"
            :coupontype="productName"
            :width=335
            :height=122
            :isActivity ="isActivityCom"
            padding="15px 12px"
            nameSize="16px"
            priceSize="32px"
            :status="sendNumber > 0 ? 1:0"
            v-on:click.native="chooseCard"
        />
        <p class="sendTime" v-if='isCanSend === 0 '><i class="el-icon-warning"></i> 发券开始时间 {{startTimeStr || '即刻'}}</p>
        <div class="opWrap">
            <el-input-number
                size="mini"
                :min="0"
                :precision="0"
                :max=" isCanSend === 0 ? 0 : availableNumber >10 ? 10: availableNumber "
                v-model="sendNumber">
            </el-input-number>
            <span class="unit">张/人</span>
            <span class="warning" v-if='warning'>{{warningTxt}}</span>
        </div>
        <p v-if="expireNum ===0">可发张数<span>{{availableNumber}}</span></p>
        <p v-else>发券后<span>{{expireNum}}</span>天过期&nbsp;&nbsp;|&nbsp;&nbsp;可发张数<span>{{availableNumber}}</span></p>
    </li>
</template>
<script>
import CouponCard from 'Components/CouponCard.vue'
export default {
  props: ['couponName', 'id', 'warning', 'warningTxt', 'productName', 'couponExplain', 'expireTimeStr', 'expireNum', 'availableNumber', 'couponAmount', 'startTimeStr', 'isCanSend', 'isActivity'],
  data () {
    return {
      sendNumber: 0
    }
  },
  components: {
    CouponCard
  },
  computed: {
    isActivityCom: function () {
      return this.isActivity === 1
    }
  },
  methods: {
    chooseCard: function () {
      if (this.sendNumber > 0) {
        this.sendNumber = 0
      } else {
        this.sendNumber = 1
      }
    }
  },
  watch: {
    sendNumber: function () {
      console.log(1515)
      this.$emit('listenCouponUnitChange', this.id, this.sendNumber, this.couponAmount, this.productName)
    }
  }
}
</script>
<style lang="stylus">
.unitCouponWrap
    padding-bottom 30px
    position relative
    .el-input-number__decrease, .el-input-number__increase
        border-radius: 50%;
        border: 2px solid #3468ff;
        width: 24px;
        height: 24px;
        color: #3468ff;
        font-size: 18px;
        font-weight: bolder;
    .el-input--mini .el-input__inner
        border none
        font-size: 24px;
        color: #333333;
    .el-input-number__decrease.is-disabled, .el-input-number__increase.is-disabled
        color: #ccc;
        border: 2px solid #ccc;
    .opWrap
        margin-top 10px
        margin-bottom 6px
        .unit
            font-size: 18px;
            color: #333333;
            padding-left 10px
        .warning
            font-size: 12px;
            color: #FF3939;
            padding-left 10px
    p
        font-size: 14px;
        color: #999999;
        span
            color #333
    .sendTime
      background #FE6E4D
      width 333px
      height 30px
      line-height 30px
      position absolute
      top 87px
      left 1px
      color #fff
      text-align center

</style>
